import React from 'react'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

const strengthLevelColors = {
  0: '#ededed',
  1: '#ff4444',
  2: '#ee9e1a',
  3: '#75c232',
  4: '#008348',
}

const strengthRectangle = styled(View)`
  flex-direction: row;
  flex: 1;
  background-color: ${props => strengthLevelColors[props.level || 0]};
  min-height: 6px;
  max-height: 6px;
  border-radius: 3px;
`

strengthRectangle.defaultProps = {
  level: 0,
}

export default strengthRectangle
